import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-eb61f108"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"width":"1150px","margin":"0 auto"} }
const _hoisted_2 = { style: {"margin-bottom":"10px","overflow":"hidden"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"12px","color":"#F56C6C","margin-left":"20px"} }, "拖动左侧按钮可将相应内容移至右侧区域", -1))
const _hoisted_4 = { style: {"float":"right"} }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["id"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["src"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "watermark" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { key: 3 }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "footerButtom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_vue_draggable_resizable = _resolveComponent("vue-draggable-resizable")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_Rank = _resolveComponent("Rank")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_row = _resolveComponent("el-row")!
  const _directive_print = _resolveDirective("print")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_select, {
          modelValue: _ctx.code,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.code) = $event)),
          class: "m-2",
          placeholder: "提单类型",
          style: {"width":"285.5px"}
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optLadingBillType, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item.Code,
                label: item.Label,
                value: item.Code
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_checkbox, {
            modelValue: _ctx.isBackgroundImg,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isBackgroundImg) = $event)),
            label: "是否显示背景图",
            size: "large"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { style: {"height":"100%"} }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optOrderBillElement, (p, index) => {
                    return (_openBlock(), _createBlock(_component_vue_draggable_resizable, {
                      key: index,
                      ref_for: true,
                      ref: 'vdr'+index,
                      h: 34,
                      x: p.X,
                      y: p.Y,
                      z: 999,
                      resizable: false,
                      draggable: !_ctx.isPreview,
                      onDrag: (x, y) => {_ctx.onDrag(x, y, p)},
                      onDragstop: ($event: any) => (_ctx.onDragstop(p, _ctx.index1)),
                      style: {"border":"none"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          disabled: _ctx.isPreview,
                          style: {"width":"235px"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(p.Name), 1)
                          ]),
                          _: 2
                        }, 1032, ["disabled"])
                      ]),
                      _: 2
                    }, 1032, ["x", "y", "draggable", "onDrag", "onDragstop"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 18 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_tabs, {
                modelValue: _ctx.activeName,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.activeName) = $event)),
                type: "border-card",
                class: "demo-tabs",
                closable: "",
                addable: "",
                onTabAdd: _ctx.tabAdd,
                onTabRemove: _ctx.tabRemove,
                onTabClick: _ctx.tabClick
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optOrderBillTamplate, (p, index) => {
                    return (_openBlock(), _createBlock(_component_el_tab_pane, {
                      key: index,
                      name: p.Name
                    }, {
                      label: _withCtx(() => [
                        _createElementVNode("span", {
                          class: _normalizeClass(`custom-tabs-label item${index}`)
                        }, [
                          _createElementVNode("span", null, _toDisplayString(p.PageType == 'A'?'正页':'副页'), 1),
                          (index > 1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(index), 1))
                            : _createCommentVNode("", true)
                        ], 2)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_card, { class: "elCard" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              id: `printBox`+index,
                              style: {"width":"210mm","height":"297mm","margin":"20px"}
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.Props, (r, index2) => {
                                return (_openBlock(), _createElementBlock("div", { key: index2 }, [
                                  _createVNode(_component_vue_draggable_resizable, {
                                    ref_for: true,
                                    ref: 'vr'+index2,
                                    w: r.W,
                                    h: r.H,
                                    x: r.X,
                                    y: r.Y,
                                    z: 1000,
                                    "min-height": 34,
                                    "min-width": 100,
                                    draggable: false,
                                    resizable: _ctx.isPreview ? false : true,
                                    style: {"border":"none"},
                                    onResize: (handle, x, y, width, height) => { _ctx.onResizeCallback(handle, x, y, width, height, r) }
                                  }, {
                                    default: _withCtx(() => [
                                      (r.Code == 'Logo' || r.Code == 'SignImg')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                            _createElementVNode("img", {
                                              src: r.Text,
                                              style: _normalizeStyle(`width: ${r.W}px; height: ${r.H}px`)
                                            }, null, 12, _hoisted_8)
                                          ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                            (!_ctx.isPreview)
                                              ? (_openBlock(), _createBlock(_component_el_input, {
                                                  key: 0,
                                                  type: "textarea",
                                                  autosize: "",
                                                  modelValue: r.Text,
                                                  "onUpdate:modelValue": ($event: any) => ((r.Text) = $event),
                                                  class: "inputPreview"
                                                }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                              : (_openBlock(), _createElementBlock("span", {
                                                  key: 1,
                                                  class: "spanPreview",
                                                  innerHTML: _ctx.HTMLEncode(r.Text)
                                                }, null, 8, _hoisted_10))
                                          ]))
                                    ]),
                                    _: 2
                                  }, 1032, ["w", "h", "x", "y", "resizable", "onResize"]),
                                  (!_ctx.isPreview)
                                    ? (_openBlock(), _createBlock(_component_vue_draggable_resizable, {
                                        key: 0,
                                        ref_for: true,
                                        ref: 'vd'+index2,
                                        w: 14,
                                        h: 14,
                                        x: r.Xd,
                                        y: r.Yd,
                                        z: 1000,
                                        draggable: _ctx.isPreview ? false : true,
                                        resizable: false,
                                        style: {"border":"none"},
                                        onDrag: (x, y) => { _ctx.onDrag2(x, y, r) },
                                        onDragstop: ($event: any) => (_ctx.onDragStopPreview(r, index2))
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_icon, { class: "rank" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_Rank)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 2
                                      }, 1032, ["x", "y", "draggable", "onDrag", "onDragstop"]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128)),
                              _createElementVNode("div", _hoisted_11, [
                                (_ctx.code == '10')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, "ORIGINAL"))
                                  : (_ctx.code == '20')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, "COPY"))
                                    : (_ctx.code == '30')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, "TELEX RELEASE"))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_15))
                              ]),
                              (p.File && _ctx.isBackgroundImg)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: p.File,
                                    style: {"width":"100%"}
                                  }, null, 8, _hoisted_16))
                                : _createCommentVNode("", true)
                            ], 8, _hoisted_6)
                          ]),
                          _: 2
                        }, 1024),
                        _createElementVNode("div", _hoisted_17, [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            size: "small",
                            class: "buttom",
                            onClick: _ctx.onSave
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("保存")
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_el_button, {
                            type: "primary",
                            size: "small",
                            class: "buttom",
                            onClick: _ctx.onReset
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("重置")
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                            type: "primary",
                            size: "small",
                            class: "buttom",
                            onClick: _ctx.onPrint
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("打印")
                            ]),
                            _: 2
                          }, 1032, ["onClick"])), [
                            [_directive_print, `printBox`+index]
                          ]),
                          _createVNode(_component_el_button, {
                            size: "small",
                            class: "buttom",
                            onClick: _ctx.onBack
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("返回")
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["name"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "onTabAdd", "onTabRemove", "onTabClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}